/* E-Tech61 site UI: quick add-to-basket buttons and auto-scrolling product rows. */
(() => {
  const T = window.theme || {};

  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Add variants to the basket and open the theme's cart drawer (same flow as the product pages).
  const addToCart = (items, btn) => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    btn.setAttribute('aria-busy', 'true');
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections, sections_url: location.pathname })
    })
      .then((r) => r.json())
      .then((res) => fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null).then((cart) => {
        cart = cart || {};
        if (res.status) {
          btn.dataset.state = 'error';
          btn.title = res.description || res.message || 'Could not add to basket';
          announce(btn.title);
          setTimeout(() => { delete btn.dataset.state; }, 4000);
          return;
        }
        const sectionsOk = res.sections && Object.values(res.sections).every(Boolean);
        if (sectionsOk) cart.sections = res.sections;
        if (T.pubsub && T.pubsub.PUB_SUB_EVENTS) T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart });
        btn.dataset.state = 'added';
        announce('Added to basket');
        const label = btn.querySelector('span');
        const before = label ? label.textContent : '';
        if (label) label.textContent = 'Added';
        setTimeout(() => { delete btn.dataset.state; if (label) label.textContent = before; }, 2000);
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.show !== 'function' || (T.settings && T.settings.cartType === 'page')) location.href = base + 'cart';
        else if (sectionsOk) drawer.show(btn);
        else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      }))
      .catch(() => { btn.dataset.state = 'error'; announce('Could not add to basket. Please try again.'); setTimeout(() => { delete btn.dataset.state; }, 4000); })
      .finally(() => btn.removeAttribute('aria-busy'));
  };
  window.et61AddToCart = addToCart;

  // Screen-reader announcement for basket actions.
  const live = document.createElement('p');
  live.className = 'sr-only';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(live));
  const announce = (msg) => { live.textContent = ''; setTimeout(() => { live.textContent = msg; }, 50); };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-et61-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    addToCart([{ id: +btn.dataset.et61Add, quantity: 1 }], btn);
  });

  // Auto-scroll home product rows; pauses while the shopper hovers, touches or tabs into a row,
  // and each row gets a Pause button (moving content must be stoppable).
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timers = new Map();
  const setupRow = (section) => {
    if (reduce || timers.has(section)) return;
    const sliders = section.querySelectorAll('slider-element');
    if (!sliders.length) return;
    let paused = false, userPaused = false, resumeTimer;
    const visible = new Set();
    const pause = () => { paused = true; clearTimeout(resumeTimer); };
    const resume = (delay = 0) => { clearTimeout(resumeTimer); resumeTimer = setTimeout(() => { paused = false; }, delay); };
    section.addEventListener('pointerenter', pause);
    section.addEventListener('pointerleave', () => resume());
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', () => resume());
    section.addEventListener('touchstart', () => { pause(); resume(8000); }, { passive: true });
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { en.isIntersecting ? visible.add(en.target) : visible.delete(en.target); }), { threshold: 0.3 });
    sliders.forEach((sl) => io.observe(sl));
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'et61-pause';
    btn.setAttribute('aria-pressed', 'false');
    btn.textContent = 'Pause';
    btn.addEventListener('click', () => {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', String(userPaused));
      btn.textContent = userPaused ? 'Play' : 'Pause';
    });
    const nav = section.querySelector('.tab-list');
    (nav || section).appendChild(btn);
    const id = setInterval(() => {
      if (paused || userPaused || document.hidden) return;
      sliders.forEach((slider) => {
        if (!visible.has(slider) || slider.clientWidth === 0) return;
        const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 8;
        if (atEnd) slider.scrollTo({ left: 0, behavior: 'smooth' });
        else if (typeof slider.next === 'function') slider.next();
      });
    }, 3500);
    timers.set(section, () => { clearInterval(id); io.disconnect(); });
  };
  const rowSelector = '.template-index [id*="__featured-collections"], .template-index [id*="__et61-best-sellers"]';
  document.querySelectorAll(rowSelector).forEach(setupRow);
  // Theme editor re-renders sections: clean up and start again.
  document.addEventListener('shopify:section:unload', (e) => { const stop = timers.get(e.target); if (stop) { stop(); timers.delete(e.target); } });
  document.addEventListener('shopify:section:load', (e) => { if (e.target.matches(rowSelector)) setupRow(e.target); });

  // Pause button for the hero best-seller strip.
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-et61-pause-strip]');
    if (!b) return;
    const strip = b.closest('.et61-hs__products');
    const on = strip.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', String(on));
    b.textContent = on ? 'Play' : 'Pause';
  });
})();
